import React, { useState, useEffect } from 'react';
import { Button, Modal, Col, Stack, Table, Row } from 'react-bootstrap';

function DiastemaButtonModal({
    getDataDentalDiastema,
    cleanedTooth,
    toothDiastema,
    setToothDiastema,
    selectedTeeth,
    activeDiastemaSelections,
    setActiveDiastemaSelections,
    tempDiastemaSelections,
    setTempDiastemaSelections,
    activeMode,
    setActiveMode,
    onDiastemaSelected,
    onDiastemaDescriptionChange,
    onModalOpen,
    setOpenModalType,
}) {
    const [showModal, setShowModal] = useState(false);
    const sourceData = getDataDentalDiastema || [];
    const [description, setDescription] = useState('');

    const grayColor = '#6c757d';

    const applyToSingleTooth = () => {
        if (tempDiastemaSelections.length === 0) return;

        const selected = tempDiastemaSelections[0];
        const id = selected.id;
        const label = selected.label;

        setActiveDiastemaSelections([id]);
        setToothDiastema(prev => ({
            ...prev,
            [cleanedTooth]: [id],
        }));

        if (!selectedTeeth.includes(cleanedTooth)) {
            selectedTeeth.push(cleanedTooth);
        }

        if (typeof onDiastemaSelected === 'function') {
            onDiastemaSelected([label]);
        }

        setShowModal(false);
    };

    useEffect(() => {
        if (showModal && typeof onModalOpen === 'function') {
            onModalOpen();
        }
    }, [showModal]);

    useEffect(() => {
        if (showModal) {
            const currentIds = toothDiastema[cleanedTooth] || [];
            const updated = sourceData
                .filter(item => currentIds.includes(item.id))
                .map(item => ({ id: item.id, label: item.display_name }));
            setTempDiastemaSelections(updated);
        }
    }, [showModal, cleanedTooth, toothDiastema, sourceData]);

    const handleSelect = (item) => {
        const isSelected = tempDiastemaSelections.some(sel => sel.id === item.id);
        setTempDiastemaSelections(isSelected ? [] : [{ id: item.id, label: item.display_name }]);
    };

    return (
        <>
            <Col>
                <Stack>
                    {(toothDiastema?.[cleanedTooth]?.length > 0) ? (
                        <Table
                            bordered
                            size="sm"
                            className="mt-2 mb-0"
                            style={{
                                cursor: 'pointer',
                                fontSize: '0.8rem',
                                width: 'auto',
                                maxWidth: '250px',
                                borderColor: '#dee2e6'
                            }}
                            onClick={() => setShowModal(true)}
                        >
                            <thead className="table-light">
                                <tr>
                                    <th
                                        style={{
                                            padding: '4px 8px',
                                            backgroundColor: '#dee2e6',
                                            fontWeight: '600',
                                            fontSize: '0.75rem',
                                            textAlign: 'left',
                                            color: '#343a40'
                                        }}
                                    >
                                        Diastema
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {(toothDiastema?.[cleanedTooth] || []).map((id, idx) => {
                                    const item = sourceData.find(i => i.id === id);
                                    return (
                                        <tr key={id || idx}>
                                            <td style={{ padding: '4px 8px' }}>&bull; {item?.display_name || '-'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    ) : (
                        <Button
                            size="sm"
                            onClick={() => {
                                setShowModal(true)
                                setOpenModalType('diastema')
                            }}
                            style={{
                                width: '100%',
                                whiteSpace: 'normal',
                                wordWrap: 'break-word',
                                textAlign: 'center',
                                fontSize: '0.75rem',
                                lineHeight: '1rem',
                                padding: '4px',
                                backgroundColor: 'transparent',
                                color: '#343a40',
                                borderColor: '#ced4da',
                                borderWidth: '1px',
                                borderStyle: 'solid',
                            }}
                        >
                            Diastema
                        </Button>
                    )}
                </Stack>
            </Col>


            <Modal size="lg" show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <strong>Pilih Diastema</strong>
                </Modal.Header>
                <Modal.Body
                    className="text-center"
                    style={{
                        border: `2px solid ${grayColor}`,
                        color: '#000',
                        borderRadius: '6px',
                        padding: '20px'
                    }}
                >
                    <Row className="justify-content-center">
                        {sourceData.map(item => {
                            const isChecked = tempDiastemaSelections.some(sel => sel.id === item.id);
                            return (
                                <Col key={item.id} md="auto" className="mb-2">
                                    <Button
                                        size="sm"
                                        onClick={() => handleSelect(item)}
                                        style={{
                                            backgroundColor: isChecked ? '#dee2e6' : 'transparent',
                                            color: '#000000',
                                            borderColor: grayColor,
                                            borderWidth: '1px',
                                            borderStyle: 'solid',
                                            borderRadius: '6px',
                                            padding: '6px 12px',
                                            fontWeight: 500,
                                            minWidth: '100px'
                                        }}
                                    >
                                        {item.display_name}
                                    </Button>
                                </Col>
                            );
                        })}

                        {/* Textarea muncul jika ada pilihan diastema */}
                        {tempDiastemaSelections[0]?.label === 'Ada Diastema' && (
                            <Col md={12}>
                                <textarea
                                    className="form-control mt-3"
                                    rows={3}
                                    placeholder="Masukkan keterangan..."
                                    value={description}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setDescription(value);
                                        if (typeof onDiastemaDescriptionChange === 'function') {
                                            onDiastemaDescriptionChange(value);
                                        }
                                    }}
                                />
                            </Col>
                        )}
                    </Row>


                    <div className="d-flex justify-content-end mt-3">
                        <Button
                            size="sm"
                            onClick={applyToSingleTooth}
                            style={{
                                backgroundColor: grayColor,
                                borderColor: grayColor,
                                color: '#fff'
                            }}
                        >
                            Pilih
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default DiastemaButtonModal;
